@if (largeView) {
  <gtapp-gt-table
    [desktopTableBackendData]="userEvents"
    [desktopTableDetails]="userEventDetailsTableView"
    [tableStyle]="tableStyle"
    (rowClick)="onTableRowClick($event)"
    (sortColumn)="sortColumn($event)"
    (searchColumn)="searchColumn($event)"
    [otherParams]="otherParams"
    (paginationChange)="onPaginationChange($event)"
  ></gtapp-gt-table>
} @else {
  @if (!selectedEvent) {
    <gtapp-infinite-list
      [mobileCardBackendData]="infiniteDataList"
      [mobileCardDetails]="userEventDetailsMobileView"
      [totalRows]="totalRows"
      (loadMoreData)="previous = previous + pageSize; getUserUpdateLog()"
      (rowClick)="onTableRowClick($event)"
      (sortColumn)="sortColumn($event)"
      (searchColumn)="searchColumn($event)"
    ></gtapp-infinite-list>
  }
}
@if (selectedEvent) {
  <gtapp-selected-event-detail
    [selectedEvent]="selectedEvent"
    [selectedEventFrom]="eventType"
    [userEventDetailsTableView]="userEventDetailsTableView"
    [extraCheck]="true"
    (goBack)="hideDetails()"
  ></gtapp-selected-event-detail>
}
